export const SUBMIT_USOB_DASHBOARD_SUMMARY_ACTION_REQUESTED =
  "SUBMIT_USOB_DASHBOARD_SUMMARY_ACTION_REQUESTED";
export const SUBMIT_USOB_DASHBOARD_SUMMARY_ACTION_DISPATCHER =
  "SUBMIT_USOB_DASHBOARD_SUMMARY_ACTION_DISPATCHER";
export const SUBMIT_USOB_DASHBOARD_SUMMARY_ERROR_DISPATCHER =
  "SUBMIT_USOB_DASHBOARD_SUMMARY_ERROR_DISPATCHER";
export const USOB_DASHBOARD_SUMMARY_LOADING =
  "USOB_DASHBOARD_SUMMARY_LOADING";

//Action Creator
export const submitUSOBDashboardSummaryAction = (data) => ({
  type: SUBMIT_USOB_DASHBOARD_SUMMARY_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitUSOBDashboardSummaryActionDispatcher = (data) => ({
  type: SUBMIT_USOB_DASHBOARD_SUMMARY_ACTION_DISPATCHER,
  payload: data,
});

export const submitUSOBDashboardSummaryErrorDispatcher = (data) => ({
  type: SUBMIT_USOB_DASHBOARD_SUMMARY_ERROR_DISPATCHER,
  payload: data,
});

export const USOBDashboardSummaryLoading = (loading) => ({
  type: USOB_DASHBOARD_SUMMARY_LOADING,
  payload: loading,
});
